<template>
  <div class="fotersa">
    <div class="head-input">
      <a-form :layout="formLayout">
        <a-row :gutter="24" type="flex" justify="start">
          <a-col :span="6" class="fl fw">
            <a-form-item label="权益商品编号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input placeholder="请输入" v-model="goodCode" :allowClear="true" />
            </a-form-item>
          </a-col>
          <a-col :span="6" class="fl1 fw">
            <a-form-item label="权益商品名称" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input placeholder="请输入" :allowClear="true" v-model="goodName" />
            </a-form-item>
          </a-col>

          <a-col :span="4" class="oper">
            <div style="height: 41px; line-height: 41px">
              <a-button class="btone" style="margin-left: -4px" @click="searchList(1)">查询</a-button>
              <a-button class="bttwo" @click="showModal()">新增</a-button>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 展示内容 -->
    <div class="base-content">
      <!-- 表格 -->
      <a-table :columns="columns" :rowKey="(record, index) => {
        return index;
        tableData;
      }
        " :data-source="tableData" :pagination="false" bordered size="small"
        :scroll="{ x: 900, y: 'calc(100vh - 300px)' }">
        <div slot="index" slot-scope="text, record, index">
          {{ index + (pageNum - 1) * pageSize + 1 }}
        </div>
        <span slot="expiryDate" slot-scope="text, record">
          {{ record.expiryDate | DictionaryFilter("GOOD_VALIDITY") }}
        </span>

        <!-- 操作 -->
        <div slot="operation" slot-scope="text">
          <a-dropdown>
            <a-menu slot="overlay" style="text-align: center">
              <a-menu-item key="1">
                <a href="javascript:;" class="modification" @click="onDelete(text, 'update')">编辑</a></a-menu-item>
              <a-menu-item key="2">
                <a href="javascript:;" class="modification" @click="handleDelete(text)">删除</a>
              </a-menu-item>
            </a-menu>
            <a-button style="margin-left: 8px" class="btaction">
              更多操作 <a-icon type="down" />
            </a-button>
          </a-dropdown>
        </div>
      </a-table>
      <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancelImg" class="imgBox">
        <img alt="example" style="width: 100%" :src="previewImage" />
      </a-modal>
      <!-- 分页 -->
      <div class="base-pagination">
        <div class="total-view">
          共{{ totalRows }}条数据，第{{ pageNum }}/{{ totalPages }}页
        </div>
        <div class="pagination-buttons">
          <a-pagination v-model="pageNum" :total="totalRows" :defaultPageSize="pageSize" show-less-items
            @change="changePageFn($event)" />
        </div>
      </div>
      <!-- 确定新增 + 编辑 -->
      <a-modal v-model="visible" on-ok="handleOk" width="1000px" :destroyOnClose="true"
        :maskClosable="false" v-if="visible" @cancel="handleCancel">
        <div slot="title" class="tip-icon"> {{Title}} </div>
        <template slot="footer">
          <a-button key="submit" class="btaction" :loading="loading" @click="handleOk" :disabled="disabled">
            确认
          </a-button>
        </template>
        <div class="add-mess">
          <a-form-model ref="ruleForm" :model="form" :rules="rules" class="input-input" :label-col="labelCol"
            :wrapper-col="wrapperCol">
            <a-row>
              <a-col :span="12">
                <a-form-model-item ref="goodName" label="权益商品名称" prop="goodName">
                  <a-input :disabled="disabled" v-model="form.goodName" placeholder="请输入权益商品名称" />
                </a-form-model-item>
              </a-col>

              <a-col :span="12">
                <a-form-model-item ref="goodCode" label="权益商品编号" prop="goodCode">
                  <a-input :disabled="disabled" v-model="form.goodCode" placeholder="请输入权益商品编号" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item ref="goodPrice" label="权益商品单价" prop="goodPrice">
                  <a-input type="number" suffix="元" style="width: 317px" :disabled="disabled" v-model="form.goodPrice"
                    placeholder="请输入权益商品单价" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item ref="expiryDate" label="有效期限" prop="expiryDate">
                  <a-select show-search v-model="form.expiryDate" placeholder="请选择有效期限">
                    <a-select-option v-for="item in goodValidity" :key="item.busCode" :value="item.busCode">{{
                      item.busName }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item ref="goodRemark" label="商品说明" prop="goodRemark" :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 20 }">
                  <a-input :disabled="disabled" v-model="form.goodRemark" placeholder="请输入商品说明" type="textarea"
                    style="height: 80px" />
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </div>
      </a-modal>
    </div>
  </div>
</template>
<script>
import upload from "@/components/upload/upload.vue";
import {
  goodList, goodAdd, goodDel, goodUpdate, goodListOne
} from "@/api/api.js";
import { DictionaryService } from "@common/services/dictionary.service";
import moment from "moment";
moment.locale("zh-cn");

export default {

  components: { upload },
  data() {
    var checkAge = (rule, value, callback) => {
      let reg =
        /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
      if (!value) {
          return callback(new Error("请输入权益商品单价"));
      }  else if (Number(value) < 0) {
        return callback(new Error('请输入大于等于0的数'));
      } else if (String(parseInt(value)).length > 8) {
        return callback(new Error("请输入整数位不超过8个字符"));
      } else if (!reg.test(value)) {
        return  callback(new Error("小数点后最多只能输入两位"));
      } else {
        return  callback();
      }
    };
    return {
      videoPreviewVisible: false,
      filesAsset: [],
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      goodCode: "", //套餐编号
      goodName: "", //套餐名称
      //表格
      tableData: [],
      Title: "",
      //新增弹出框
      visible: false,
      id: "",
      uplodImgId: "",
      isSelect: "1", //是否展示发放数量
      // 表单验证
      rules: {
        goodName: [
          {
            required: true,
            message: "请输入权益商品名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        goodRemark: [
          {
            required: true,
            message: "请输入商品说明",
            trigger: "blur",
          },
          {
            max: 100,
            message: "商品说明长度不能超过100",
          },
        ],
        goodCode: [
          {
            required: true,
            message: "请输入权益商品编号",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        goodPrice: [
          {
            required:true,
            validator: checkAge,
            trigger: "change",
          },
        ],
        expiryDate: [
          {
            required: true,
            message: "请选择有效期限",
            trigger: "blur",
          }
        ],
      },
      form: {
        goodName: "",
        goodRemark: "",
        goodCode: "",
        goodPrice: "",
        expiryDate: undefined,
      },
      //组件列表是否存在
      imgSts: '',
      loading: false,
      Tableloading: false,
      disabled: false,
      //数列
      columns: [
        {
          title: "序号",
          align: "center",
          dataIndex: "index",
          width: 40,
          key: "index",
          ellipsis: true,
          scopedSlots: { customRender: "index" },
        },
        {
          title: "权益编号",
          dataIndex: "goodCode",
          key: "goodCode",
          align: "center",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "权益编号" },
        },
        {
          title: "权益商品名称",
          dataIndex: "goodName",
          key: "goodName",
          align: "center",
          ellipsis: true,
          width: 150,
          scopedSlots: { customRender: "goodName" },
        },
        {
          title: "已消费数量",
          dataIndex: "usedCount",
          key: "usedCount",
          align: "center",
          ellipsis: true,
          width: 80,
          scopedSlots: { customRender: "usedCount" },
        },
        {
          title: "待销费数量",
          dataIndex: "waitCount",
          key: "waitCount",
          align: "center",
          ellipsis: true,
          width: 80,
          scopedSlots: { customRender: "waitCount" },
        },
        {
          title: "待过期数量",
          dataIndex: "unexpiredCount",
          key: "unexpiredCount",
          align: "center",
          ellipsis: true,
          width: 80,
          scopedSlots: { customRender: "unexpiredCount" },
        },

        {
          title: "商品单价(元)",
          dataIndex: "goodPrice",
          key: "goodPrice",
          align: "center",
          ellipsis: true,
          width: 120,
          scopedSlots: { customRender: "goodPrice" },
        },
        {
          title: "有效期限",
          dataIndex: "expiryDate",
          key: "expiryDate",
          align: "center",
          ellipsis: true,
          width: 70,
          scopedSlots: { customRender: "expiryDate" },
        },

        {
          title: "操作",
          key: "operation",
          align: "center",
          width: 100,
          scopedSlots: {
            customRender: "operation",
          },
        },
      ],
      pageNum: 1,
      pageSize: 10,
      totalRows: 0,
      totalPages: 0,
      goodValidity: [],
      formLayout: "horizontal",
      url: "",
      previewVisible: false,
      previewImage: "",
      bigurl: "",
      isMOdy: false,
      list: [],
    };
  },

  watch: {
    Title(newVal, oldVal) {
      if (
        (oldVal === "权益商品修改" || oldVal === "字典详情") &&
        this.visible == true
      ) {
        if (newVal == "权益商品新增") {
          this.form = this.$options.data().form;
        }
      }
    },
  },
  activated() {
    DictionaryService.getAllNeedDic(["GOOD_VALIDITY", "GRANT_TYPE"]).then((res) => {
      this.goodValidity = DictionaryService.getOptions("GOOD_VALIDITY");
      this.searchList();
    });
  },
  computed: {
    formItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
          labelCol: { span: 6 },
          wrapperCol: { span: 18 },
        }
        : {};
    },
    buttonItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
          wrapperCol: { span: 6, offset: 18 },
        }
        : {};
    },
  },
  methods: {
    listen(val) {
      if (val.length == 0) {
        this.imgSts = false;
      } else {

        this.imgSts = true
      }
    },
    getmsg(val) {
      this.list = val;
    },
    /* 表格图片查看 */
    handleImg(file) {
      this.previewVisible = true;
      this.bigurl = process.env.VUE_APP_PROXY + "base/file/download-file?id=";
      this.previewImage = this.bigurl + file;
    },
    /* 表格图片关闭 */
    handleCancelImg() {
      this.previewVisible = false;
    },
    //分页
    changePageFn(event) {
      this.pageNum = event;
      this.searchList();
    },
    //列表查询
    searchList(sum = 2) {
      if (sum == 1) this.pageNum = 1;
      let obj = {
        pageParam: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          orderBy: "",
        },
        content: {
          goodCode: this.goodCode,
          goodName: this.goodName,
        },
      };
      goodList(obj).then(
        (res) => {
          this.tableData = res.content.rows;
          this.totalRows = res.content.page.totalRows;
          this.totalPages = Math.ceil(this.totalRows / this.pageSize);
        },
        (err) => { }
      );
    },
    // 关闭箭头的回调
    handleCancel(e) {
      this.$refs["ruleForm"].resetFields();
      this.form.remark = "";
    },
    //新增弹窗
    showModal() {
      //弹窗弹出
      this.disabled = false;
      this.visible = true;
      this.Title = "权益商品新增";
      this.isMOdy = false;
    },
    onDelete(key, type) {
      type == "update"
        ? ((this.Title = "权益商品修改"), (this.disabled = false))
        : ((this.Title = "字典详情"), (this.disabled = true));
      this.visible = true;
      this.form.id = key.id;
      let obj = {
        id: key.id
      };
      goodListOne(obj).then(
        (res) => {
          const row = res.content
          this.form.id = row.id
          this.form.goodName = row.goodName
          this.form.goodCode = row.goodCode
          this.form.goodPrice = row.goodPrice
          this.form.goodRemark = row.goodRemark
          this.form.expiryDate = row.expiryDate

        },
        (err) => {
        }
      );
    },
    // 确定新增 + 编辑
    handleOk(e) {
      this.loading = true;
      // 判断是新增还是编辑
      if (this.Title == "权益商品修改") {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            goodUpdate({
              id: this.form.id,
              goodCode: this.form.goodCode,
              goodName: this.form.goodName,
              goodPrice: this.form.goodPrice,
              goodRemark: this.form.goodRemark,
              expiryDate: this.form.expiryDate,
            }).then(
              (res) => {
                this.$nextTick(() => {
                  this.$refs["ruleForm"].resetFields();
                });

                this.visible = false;
                this.loading = false;
                this.searchList();
                this.$message.success("修改成功");
              },
              (err) => {
                this.loading = false;
              }
            );
          } else {
            this.loading = false;
            return false;
          }
        });
      } else if (this.Title == "权益商品新增") {
        setTimeout(() => {
          // 校验表单
          this.$refs.ruleForm.validate((valid) => {
            if (valid) {
              goodAdd({
                goodCode: this.form.goodCode,
                goodName: this.form.goodName,
                goodPrice: this.form.goodPrice,
                goodRemark: this.form.goodRemark,
                expiryDate: this.form.expiryDate,
              }).then(
                (res) => {
                  this.loading = false;
                  this.visible = false;
                  this.searchList();
                  this.$message.success("添加成功");
                  this.form.remark = "";
                  this.$refs["ruleForm"].resetFields();
                  this.isSelect=1
                },
                (err) => {
                  this.loading = false;
                }
              );
            } else {
              this.loading = false;
              return false;
            }
          });
        });
      }
    },

    //上传图片
    async handlePreview(file) {
      this.videoPreviewVisible = true;
      this.$nextTick(() => {
        //这里一定要使用nextTick,否则document将找不到id为video的节点,因为modal框初始为隐藏状态,<video id='video'>标签初始在dom树中并不存在
        const video = document.getElementById("video");
        video.src = file.thumbUrl;
      });
    },
    handleRemove(file) {
      const index = this.filesAsset.indexOf(file);
      const newFileList = this.filesAsset.slice();
      newFileList.splice(index, 1);
      this.filesAsset = newFileList;
    },
    beforeUpload(file) {
      const isLt50M = file.size / 1024 / 1024 < 50;
      const reader = new FileReader();
      return new Promise((resolve, reject) => {
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          if (isLt50M) {
            file.thumbUrl = e.target.result;
            this.filesAsset = [...this.filesAsset, file];
            return false; // 阻止自动上传动作
          } else {
            /* this.$message.error("请检查图片格式和大小!"); */
            reject(file);
          }
        };
        reader.onerror = (error) => reject(error);
      });
    },
    /* 图片弹框取消 */
    videoPreviewCancel() {
      this.videoPreviewVisible = false;
    },

    //删除
    handleDelete(text) {
      this.$confirm({
        title: "确定是否删除?",
        okText: "是",
        cancelText: "否",
        onOk: () => {
          goodDel({ id: text.id }).then(
            (res) => {
              this.$message.success("删除成功");
              this.searchList();
            },
            (err) => { }
          );
        },
        onCancel: () => { },
      });
    },
    //禁用启用
    up(list) {
      let status = list.pgStatus;
      this.$confirm({
        title: status == 1 ? "确认禁用吗？" : "确认启用吗？",
        okText: "是",
        cancelText: "否",
        onOk: () => {
          serStatus({ id: list.id }).then(
            (res) => {
              this.searchList();
              this.$message.success("设置成功");
            },
            (err) => {
              this.$message.error("设置失败");
            }
          );
        },
        onCancel: () => { },
      });
    },
  },
};
</script>
<style lang="less" scoped="scoped">
/deep/ .ant-modal-body {
  max-height: 450px;
  overflow-y: auto;
}

.bbbbtttt {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  text-shadow: none;
  box-shadow: none;
}

.base-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/deep/.ant-table-body {
  margin-top: -8px !important;
}

.sp_name {
  display: inline-block;
  font-size: 20px;
  margin: 0 0 20px 10px;
}

.fotersa {
  width: 100%;
  height: 100%;

  .title-name {
    width: 100%;
    height: 46px;
    overflow: hidden;

    .sp_name {
      display: inline-block;
      font-size: 20px;
      margin: 0 0 20px 10px;
    }
  }

  .flex {
    display: flex;
    align-items: center;
  }

  .flex label {
    font-size: 16px;
    width: 73px;
  }

  .btone {
    margin-right: 20px;
  }

  /deep/.ant-table-thead {
    background-color: #dcf4ff;
  }

  a {
    margin-left: 10px;
  }

  a:hover {
    color: #70b9cf;
  }
}

/deep/.ant-form-item {
  margin-bottom: 0;
}

.title-name::before {
  content: "";
  width: 5px;
  height: 20px;
  display: inline-block;
  overflow: hidden;
  background-color: #0b2464;
}

/deep/ .ant-table-body {
  max-height: 487px;
  overflow: auto;
  margin: 0 !important;
}

/deep/.ant-table-tbody>tr>td {
  padding: 11px 16px;
}

.add-mess {
  width: 100%;
  height: 100%;
  //overflow: auto;

  /deep/ .ant-form-item {
    //display: flex;
    margin-bottom: 20px !important;
  }

  /deep/ .ant-form-item-label {
    width: 110px;
  }
}

/deep/ .form .ant-input,
.ant-form-item-control,
.ant-form-item-control-wrapper {
  width: 160px;
}

.fw {
  width: 250px;
}

.oper {
  width: 219px;
  margin-left: 39px;
}

/deep/ .fl .ant-row .ant-col-6:nth-child(1) {
  width: 96px;
}

/deep/ .fl1 .ant-row .ant-col-6:nth-child(1) {
  width: 113px;
}

/deep/ .ant-input-affix-wrapper {
  width: 160px;
}

/deep/ .ant-col-18 {
  width: 50%;
}

.imgBox /deep/ .ant-modal-close-x {
  width: 27px !important;
  line-height: 27px !important;
}

.peitu {
  margin-left: 63px;
}
</style>